import RestService from "./restService";
import { FEEDBACK_RESULT } from "../../url/index";

const singleton = Symbol();
const singletonEnforcer = Symbol();

/**
 *
 */
class FeedbackResultService extends RestService {
  constructor(enforcer) {
    super(FEEDBACK_RESULT);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct FeedbackResult RestService more than one");
  }

  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new FeedbackResultService(singletonEnforcer);
    }
    return this[singleton];
  }
}

export default FeedbackResultService;
